import React from 'react';
import { Frame, Grid, useSageBreakpoint } from '@kajabi/sage-react';

type PropsType = {
  backgroundColor: string;
  children: React.ReactNode;
  imageUrl?: string;
};

export const StepLayout = ({
  backgroundColor,
  children,
  imageUrl,
}: PropsType) => {
  const breakpoints = useSageBreakpoint();

  return (
    <Grid style={{ maxWidth: 'unset' }}>
      <Grid.Row>
        <Grid.Col>
          <Grid container={Grid.CONTAINER_SIZES.LG}>
            <Frame
              gap={Frame.GAPS.NONE}
              padding={Frame.PADDINGS[breakpoints.md ? 'MD' : 'XXL']}
              width={Frame.WIDTHS.FLEX}
              style={{ paddingTop: breakpoints.md ? 36 : 80 }}
            >
              {children}
            </Frame>
          </Grid>
        </Grid.Col>
        {breakpoints.md || (
          <Grid.Col size={6} className={'lead-gen-step-layout__img-col'}>
            <Frame
              align={Frame.ALIGNMENTS.TOP_CENTER}
              background={backgroundColor}
              direction={Frame.DIRECTIONS.HORIZONTAL}
              style={{ overflow: 'hidden' }}
              width={Frame.WIDTHS.FLEX}
            >
              <img
                alt={imageUrl}
                src={imageUrl}
                style={{ maxHeight: '100%', maxWidth: '85%', position: 'relative', right: -60, objectFit: 'cover', overflow: 'hidden' }}
              />
            </Frame>
          </Grid.Col>
        )}
      </Grid.Row>
    </Grid>
  );
};
